const LOAD_ALL_BOOK_REQ = 'LOAD_ALL_BOOK_REQ';
const CREATE_BOOK_REQ = 'CREATE_BOOK_REQ';
const REMOVE_BOOK_REQ = 'REMOVE_BOOK_REQ';
const FILTER_BOOK_REQ = 'FILTER_BOOK_REQ';

export {
  LOAD_ALL_BOOK_REQ, CREATE_BOOK_REQ, REMOVE_BOOK_REQ, FILTER_BOOK_REQ,
};
